import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/img/horn.svg';
import _imports_1 from '@/assets/img/dr.svg';
const _withScopeId = n => (_pushScopeId("data-v-5c805a34"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "activity"
};
const _hoisted_2 = {
  class: "activity-container"
};
const _hoisted_3 = {
  class: "activity-msg"
};
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0
}, null, -1));
const _hoisted_5 = {
  class: "flex-box"
};
const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "限时免费", -1));
const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "radio"
}, null, -1));
const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1
}, null, -1));
const _hoisted_9 = {
  class: "activity-time"
};
const _hoisted_10 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "距离活动结束剩", -1));
const _hoisted_11 = {
  class: "downtime"
};
const _hoisted_12 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, ":", -1));
const _hoisted_13 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, ":", -1));
import { ref, inject, watch, computed, onMounted } from 'vue';
import { isMobile } from '@/utils';
import { useRoute, useRouter } from 'vue-router';
export default {
  __name: 'countdown',
  setup(__props) {
    const route = useRoute();
    const router = useRouter();
    const source = ref('落地页');
    watch(() => router.currentRoute.value.path, toPath => {
      if (route.meta.name) {
        source.value = '顶部导航栏_免费试用';
      }
    }, {
      immediate: true,
      deep: true
    });
    const trackOption = computed(() => {
      return {
        eventName: 'WebUserClick',
        button_name: '立即体验',
        click_info: '顶部导航栏_免费试用',
        event_source: `${source.value}`,
        event_source_pam: null,
        event_target: '留资表单',
        event_target_pam: null
      };
    });
    const hours = ref(0);
    const minutes = ref(0);
    const seconds = ref(0);
    const showPutinVisible = inject('showPutinVisible');
    const goFormModal = () => {
      if (!isMobile()) {
        return showPutinVisible(source);
      }
      return window.scrollTo({
        top: 730,
        left: 0,
        behavior: 'smooth'
      });
    };
    const countdowm = () => {
      let timestamp = getCount();
      const timer = setInterval(function () {
        const nowTime = new Date();
        const endTime = new Date(timestamp);
        const t = endTime.getTime() - nowTime.getTime();
        if (t > 0) {
          const day = Math.floor(t / 86400000);
          const hour = Math.floor(t / 3600000 % 24);
          const min = Math.floor(t / 60000 % 60);
          const sec = Math.floor(t / 1000 % 60);
          hours.value = hour < 10 ? '0' + hour : hour;
          minutes.value = min < 10 ? '0' + min : min;
          seconds.value = sec < 10 ? '0' + sec : sec;
        } else {
          timestamp = getCount();
        }
      }, 1000);
    };
    onMounted(() => {
      countdowm();
    });
    const getCount = () => {
      const date = new Date();
      const [hour, min, sec] = [23 - date.getHours(), 59 - date.getMinutes(), 59 - date.getSeconds()];
      return new Date().getTime() + hour * 60 * 60 * 1000 + min * 60 * 1000 + sec * 1000;
    };
    return (_ctx, _cache) => {
      const _directive_track = _resolveDirective("track");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_hoisted_4, _createElementVNode("div", _hoisted_5, [_createElementVNode("div", null, [_hoisted_6, _hoisted_7, _createElementVNode("span", null, _toDisplayString(_unref(isMobile)() ? '登记即领' : '申请即送50份电子合同'), 1)]), _withDirectives((_openBlock(), _createElementBlock("div", {
        class: "trial",
        onClick: goFormModal
      }, [_createTextVNode(" 免费试用"), _hoisted_8])), [[_directive_track, _unref(trackOption)]])])]), _createElementVNode("div", _hoisted_9, [_hoisted_10, _createElementVNode("div", _hoisted_11, [_createElementVNode("span", null, _toDisplayString(hours.value), 1), _hoisted_12, _createElementVNode("span", null, _toDisplayString(minutes.value), 1), _hoisted_13, _createElementVNode("span", null, _toDisplayString(seconds.value), 1)])])])]);
    };
  }
};